// removed by extract-text-webpack-plugin
module.exports = {"divider":"general__divider___vNbai height-100 pinTR position-absolute transitionDuration-s transitionProperty-all transitionTimingFunction-linear zi-chrome"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-button/ButtonDivider/style/general.css
// module id = 112
// module chunks = 0 2